import { render } from "./PosChoose.vue?vue&type=template&id=cdde27d2"
import script from "./PosChoose.vue?vue&type=script&lang=js"
export * from "./PosChoose.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__